module.exports = __webpack_public_path__ + "static/media/ab-logo-type.ec144935.png";